exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.name-box[data-v-443ce083]{margin-bottom:10px}}@media (max-width: 767px){.author--sale[data-v-443ce083]{font-size:22px}}.product-name[data-v-443ce083]{position:relative}.product-name .wishlist-button[data-v-443ce083]{position:absolute;right:0;top:-7px}@media (max-width: 767px){.product-name--rental[data-v-443ce083]{font-size:26px}}@media (max-width: 767px){.product-name--sale[data-v-443ce083]{font-size:16px}}\n", ""]);

// exports
